export const PROJECT_COMPLIANCE_STATUS = {
  COMPLIANT: 'COMPLIANT',
  NON_COMPLIANT: 'NON_COMPLIANT',
} as const;

export const PROJECT_COMPLIANCE_STATUS_LABELS = {
  [PROJECT_COMPLIANCE_STATUS.COMPLIANT]: 'Compliant',
  [PROJECT_COMPLIANCE_STATUS.NON_COMPLIANT]: 'Non-compliant',
};

export const COMPLIANCE_CONTROL_MODE = {
  ENFORCED: 'enforced',
  ADVISORY: 'advisory',
  DISABLED: 'disabled',
} as const;

export const COMPLIANCE_CONTROL_STATUS = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  TECHNICAL_FAILURE: 'TECHNICAL_FAILURE',
} as const;

export const COMPLIANCE_CONTROL_FRESHNESS = {
  FRESH: 'FRESH',
  STALE: 'STALE',
  NEVER_RUN: 'NEVER_RUN',
} as const;
